
























import Vue from "vue";
import { DocumentFieldValue } from "@infoland/iprova-api";
import DocumentField from "./DocumentField";
export default Vue.extend({
    name: "FrameworksField",
    components: {},
    props: {
        values: { type: Array as () => DocumentFieldValue[] }
    },
    data: function () {
        return {
            groupedFieldValues: {} as Map<string, DocumentFieldValue[]>,
            frameworkNames: [] as String[],
            groupModel: []
        };
    },
    methods: {},
    watch: {
        values: {
            handler(newValues: DocumentFieldValue[]) {
                newValues.forEach(element => {
                    if (!this.frameworkNames.includes(element.description)) {
                        this.frameworkNames.push(element.description);
                    }
                });
                this.frameworkNames.sort();
                this.groupedFieldValues = DocumentField.groupFieldValuesBy(this.values, values => values.description);
            },
            immediate: true
        }
    }
});
